import React, { Component } from "react";
import { StyledSection, StyledRow, StyledColumn, StyledLogoList } from "../styles/styledComponents/blocks";
import { H1, H2, H3, Strong, P, Ul, Li, A, PrimaryButton, CommitmentLogo } from "../styles/styledComponents/elements";
import cageFreeData from "../data/privacy-policy.json";
import { fromThemeProps } from "../helpers/utilities";
import Themed from "../helpers/Themed";

export default class PrivacyPolicy extends Component {
  render() {
    return <div>{this.renderMain()}</div>;
  }

  //
  // Partials
  //
  renderMain() {
    return (
      <StyledSection background={fromThemeProps("offWhite")}>
        <StyledRow paddingTop={fromThemeProps("headerHeight")}>
          <StyledColumn background="none" paddingTop="1.5em">
            <Themed alt>
              <H1>
                <span>{cageFreeData.title1}</span>
              </H1>
            </Themed>
            <br />
            <P>
              Chickenwatch.org does not collect or store any personal data, personal information, or any other data that
              could be used to identify an individual (“Personal Information”). Personal Information may be collected if
              you subscribe to updates from us.
            </P>
            <P>Chickenwatch.org does collect anonymous data through the use of cookies and pixel tags.</P>
            <H2>PERSONAL INFORMATION YOU PROVIDE</H2>
            <P>
              If you subscribe to our email updates, your Personal Information may be stored and you consent to
              Chickenwatch.org collecting and storing your Personal Information. By subscribing to our email updates,
              you further consent to being contacted via email by Chickenwatch.org
            </P>
            <H2>HOW YOUR PERSONAL INFORMATION IS USED/SHARED</H2>
            <P>
              Your Personal Information may be used to contact you about updates and important information about
              Chickenwatch.org.
            </P>
            <P>
              Chickenwatch.org will never sell your Personal Information to any third parties. Chickenwatch.org utilizes
              Google to process and store the information described herein. More information about Google’s privacy
              policy can be found on their website.
            </P>
            <H2>STORAGE</H2>
            <P>
              Chickenwatch.org keeps your Personal Information, in a form which permits us to identify you, for no
              longer than is necessary for the purposes described in this Privacy Policy. When Chickenwatch.org no
              longer needs to use your Personal Information and there is no need for Chickenwatch.org to keep it to
              comply with legal or regulatory obligations, resolve disputes, and enforce agreements, Chickenwatch.org
              will remove it from our systems.
            </P>
            <H3>COOKIES</H3>
            <P>
              Cookies are small pieces of text sent to your web browser by a website you visit. A cookie file is stored
              in your web browser and allows the service or a third-party to recognize you and make your next visit
              easier and the service more useful to you. Cookies can be "persistent" or "session" cookies.
            </P>
            <P>
              <Strong>HOW Chickenwatch.org USES COOKIES</Strong>
            </P>
            <P>
              Chickenwatch.org uses cookies to help monitor traffic and collect information about the use of the site.
              When you use this site, it may place a number of cookies files in your web browser.
            </P>
            <P>
              Chickenwatch.org uses cookies to enable certain functions of the site, to provide analytics, and to store
              your preferences.
            </P>
            <P>
              Chickenwatch.org uses both session and persistent cookies on the site and we use different types of
              cookies:
            </P>
            <P>
              <Strong>Functionality Cookies.</Strong> These cookies allow the site to remember choices you make when you
              use the site, such as dismissing a pop-up or displaying certain content.
            </P>
            <P>
              <Strong>Analytics and Performance Cookies.</Strong> These cookies are used to collect information about
              traffic to the site and how users use the site. The information gathered does not identify any individual
              visitor. The information is aggregated and anonymous. It includes the number of visitors to the site, the
              websites that referred them to the site, the pages they visited on the site, what time of day they visited
              the site, whether they have visited the site before, and other similar information. Chickenwatch.org uses
              this information to help operate the site more efficiently, to gather broad demographic information, and
              to monitor the level of activity on the site.
            </P>
            <P>
              Chickenwatch.org uses Google Analytics for this purpose. Chickenwatch.org also uses Google Analytics
              Demographics and Interest Reporting. Google Analytics uses its own cookies. It is only used to improve how
              our site works. You can find out more information about Google Analytics cookies here:
            </P>
            <P>
              <a
                href="http://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline" }}
              >
                developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
              </a>
            </P>
            <P>
              <Strong>DISABLING COOKIES</Strong>
            </P>
            <P>
              You can typically remove or reject cookies via your browser settings. In order to do this, follow the
              instructions provided by your browser (usually located within the “settings”, “help”, “tools”, or “edit”
              facility). Many browsers are set to accept cookies until you change your settings.
            </P>
            <P>
              You may opt out of Google's use of cookies by visiting the National Advertising Initiative’s Ads Settings
              at any time.
            </P>
            <P>
              Further information about cookies, including how to see what cookies have been set on your computer or
              mobile device and how to manage and delete them, visit www.allaboutcookies.org and www.cookiesandyou.com.
            </P>
            <P>
              If you do not accept the site's cookies, you may experience some inconvenience in your use of the site.
            </P>
            <H3>CALIFORNIA’S ONLINE PRIVACY PROTECTION ACT</H3>
            <P>
              The California Online Privacy Protection Act protects your right to visit our website anonymously. Some
              Internet browsers - like Internet Explorer, Firefox, and Safari - include the ability to transmit “Do Not
              Track” or “DNT” signals. Since uniform standards for “DNT” signals have not been adopted, this website
              does not currently process or respond to “DNT” signals. If you would like to opt out of Google Analytics
              specifically, try this browser add-on: Google Analytics Opt-out Browser Add-on.
            </P>
            <H3>STORAGE</H3>
            <P>
              The Personal Information collected if you subscribe to updates is stored on servers located in the United
              States. If you are visiting our site from outside the United States, be aware that your information may be
              transferred to, stored, and processed in the United States where this site’s servers are located.
            </P>
            <P>
              chickenwatch.org will not transfer Personal Information relating to individuals in the European Economic
              Area to third parties outside of the EEA without ensuring adequate protection under European law.
            </P>
            <H3>YOUR RIGHTS</H3>
            <Ul>
              <Li>You may opt out of receiving communications by emailing privacy@chickenwatch.org.</Li>
              <Li>
                If you wish to access, correct, update, or request deletion of your Personal Information, you can do so
                at any time by emailing us at privacy@chickenwatch.org.
              </Li>
              <Li>
                In addition, you can object to processing of Personal Information, ask us to restrict processing of your
                Personal Information, or request portability of your Personal Information. Again, you can exercise these
                rights by emailing us at privacy@chickenwatch.org.
              </Li>
              <Li>
                You have the right to opt-out of communications we send you at any time. To opt-out of communications,
                you may email us at privacy@chickenwatch.org.
              </Li>
              <Li>
                If we have collected and processed your Personal Information with your consent, then you can withdraw
                your consent at any time. Withdrawing your consent will not affect the lawfulness of any processing we
                conducted prior to your withdrawal, nor will it affect processing of your Personal Information conducted
                in reliance on lawful processing grounds other than consent.
              </Li>
            </Ul>
            <P>
              You have the right to complain to a data protection authority about our collection and use of your
              Personal Information. For more information, please contact your local data protection authority.
            </P>
            <P>
              Chickenwatch.org responds to all requests it receives from individuals wishing to exercise their data
              protection rights in accordance with applicable data protection laws. Notwithstanding the foregoing,
              Chickenwatch.org reserves the right to keep any information in its archives that it deems necessary to
              comply with legal obligations, resolve disputes, and enforce agreements.
            </P>
            <H3>UPDATES</H3>
            <P>
              <Strong>If you have updates for Chickenwatch.org:</Strong>
            </P>
            <P>
              If you would like to update any of the information Chickenwatch.org has on file for you, please use the
              contact information listed below. Additionally, if you prefer not to receive messages from
              Chickenwatch.org, please send a message to privacy@chickenwatch.org.
            </P>
          </StyledColumn>
        </StyledRow>
      </StyledSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js